import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Palette } from "../AppConfig";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

export const StyledTabs = withStyles((theme) => ({
    indicator: {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "transparent",
        bottom: "inherit",
        height: "4px",
        borderRadius: "2px",
        "& > span": {
            maxWidth: 80,
            width: "100%",
            backgroundColor: theme.brand.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue,
        },
    },
    fixed: {
        paddingBottom: "10px",
    },
}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

export const StyledTab = withStyles((theme) => ({
    root: {
        textTransform: theme.brand.FIELDERS ? "none" : "uppercase",
        color: theme.brand.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue,
        // fontWeight: 600,
        // font: "12pt " + (window.FIELDERS?Palette.Fielders.FontFamily:Palette.Lysaght.FontFamily),
        font: theme.brand.FIELDERS
            ? "600 12pt " + theme.typography.fontFamily
            : "600 11pt " + theme.typography.fontFamily,
        marginRight: "10px",
        minWidth: "100px",
        "&:focus": {
            opacity: 1,
        },
    },
    selected: {
        backgroundColor: "transparent !important",
        boxShadow: "none !important",
    },
}))((props) => <Tab disableRipple {...props} />);

export const SectionHeader = withStyles((theme) => ({
    sectionHeader: {
        font: (theme.brand.FIELDERS ? "14pt " : "11pt ") + theme.typography.fontFamily,
        fontWeight: theme.brand.FIELDERS ? "400" : "600",
        textTransform: theme.brand.FIELDERS ? "none" : "uppercase",
        color: Palette.Control.DarkGrey,
        verticalAlign: "text-top",
        // width: '180px',
        paddingTop: "16px",
        paddingBottom: "4px",
        whiteSpace: "nowrap",
        textAlign: "start",
        paddingLeft: "7px",
    },
}))((props) => (
    <div className={props.classes.sectionHeader} {...props}>
        {props.children}
    </div>
));

export const SectionSubHeader = withStyles((theme) => ({
    sectionSubHeader: {
        font: "12pt " + theme.typography.fontFamily,
        fontWeight: "300",
        color: Palette.Control.DarkGrey,
        verticalAlign: "text-top",
        // width: '180px',
        paddingTop: "8px",
        paddingBottom: "4px",
        whiteSpace: "nowrap",
        textAlign: "start",
        paddingLeft: "7px",
    },
}))((props) => (
    <div className={props.classes.sectionSubHeader} {...props}>
        {props.children}
    </div>
));

export const ElementHeader = withStyles((theme) => ({
    sectionHeader: {
        font: "14px " + theme.typography.fontFamily,
        fontWeight: "400",
        color: Palette.Control.DarkGrey,
        verticalAlign: "text-top",
        // width: '180px',
        paddingTop: "8px",
        paddingBottom: "4px",
        whiteSpace: "nowrap",
        textAlign: "start",
        paddingLeft: "7px",
    },
}))((props) => (
    <div className={props.classes.sectionHeader} {...props}>
        {props.children}
    </div>
));

export const SectionContainer = withStyles((theme) => ({
    sectionContainer: {
        display: "flex",
        flexDirection: "column",
    },
}))((props) => (
    <div className={props.classes.sectionContainer} {...props}>
        {props.children}
    </div>
));

export const SectionRow = withStyles((theme) => ({
    sectionRow: {
        font: "18pt " + theme.typography.fontFamily,
        fontWeight: "400",
        color: Palette.Control.DarkGrey,
        verticalAlign: "text-top",
        display: "flex",
        paddingBottom: "5px",
        flexDirection: "row",
        alignSelf: "flex-start",
        width: "100%",
        flexFlow: "wrap",
    },
}))((props) => (
    <div className={props.classes.sectionRow} {...props}>
        {props.children}
    </div>
));

export const SectionColumn = withStyles((theme) => ({
    sectionColumn: {
        font: "18pt " + theme.typography.fontFamily,
        fontWeight: "400",
        color: Palette.Control.DarkGrey,
        verticalAlign: "text-top",
        display: "flex",
        paddingBottom: "5px",
        flexDirection: "column",
        alignSelf: "flex-start",
        width: "100%",
        flexFlow: "wrap",
        flex: 1,
    },
}))((props) => (
    <div className={props.classes.sectionColumn} {...props}>
        {props.children}
    </div>
));

export const HelperText = withStyles((theme) => ({
    helperText: {
        flex: "1",
        font: "13px " + theme.typography.fontFamily,
        color: Palette.Control.DarkGrey,
        textAlign: "start",
        padding: "4px 0px 4px 10px",
        whiteSpace: "normal",
    },
}))((props) => (
    <div className={props.classes.helperText} {...props}>
        {props.children}
    </div>
));
